<template>
    <div class="d-flex flex-wrap">
        <span
            :key="index"
            :tabindex="index"
            v-b-tooltip.hover.topright
            v-for="(degree, index) in degrees"
            class="font-weight-bold"
        >
            <b-button
                id="btn-enps-research-answer-scale"
                size="sm"
                :disabled="disabled"
                :class="getButtonClass(index)"
                :pressed="buttonIsPressed(degree.value)"
                :variant="getButtonVariant(degree.value)"
                @click="onClickDegree(degree)"
            >
                {{ degree.value }}
            </b-button>
        </span>
    </div>
</template>
<script>
const FLAT_BUTTON_CLASS = 'button flat-button'
const FIRST_BUTTON_CLASS = 'button first-button'
const LAST_BUTTON_CLASS = 'button last-button'
const PRIMARY_CLASS = 'outline-primary'
const SECONDARY_CLASS = 'outline-secondary'
const DANGER_CLASS = 'outline-danger has-error'

const degrees = [
    { value: 0 },
    { value: 1 },
    { value: 2 },
    { value: 3 },
    { value: 4 },
    { value: 5 },
    { value: 6 },
    { value: 7 },
    { value: 8 },
    { value: 9 },
    { value: 10 },
]

export default {
    name: 'Scale',
    props: {
        model: [String, Number],
        disabled: Boolean,
    },
    data() {
        return {
            degrees: { ...degrees },
        }
    },
    methods: {
        onClickDegree(degree) {
            this.$emit('change', degree.value)
        },
        buttonIsPressed(degreeValue) {
            return degreeValue == this.model
        },
        getButtonClass(index) {
            const isFirstButton = index == 0
            if (isFirstButton) {
                return FIRST_BUTTON_CLASS
            }

            const isLastButton = index == 10
            if (isLastButton) {
                return LAST_BUTTON_CLASS
            }

            return FLAT_BUTTON_CLASS
        },
        getButtonVariant(degreeValue) {
            if (this.state === false) {
                return DANGER_CLASS
            }

            if (!this.hasScore) {
                return SECONDARY_CLASS
            }

            if (this.disabled && this.model !== degreeValue) {
                return SECONDARY_CLASS
            }

            if (this.model === degreeValue) {
                return PRIMARY_CLASS
            }

            return SECONDARY_CLASS
        },
    },
}
</script>
<style scoped lang="sass">
$radius: .2rem
$blue: #20a8d8

.button
    width: 40px
    height: 35px
    font-weight: bold

.flat-button
    border-radius: 0
    border-right: none

.first-button
    border-radius: $radius 0 0 $radius
    border-right: none

.last-button
    border-radius: 0 $radius $radius 0
    padding: 0 !important

.btn-outline-secondary
    color: #3B3F4E
    border-color: $blue
    border-width: 2px
    &:hover
        background-color: white
    &:active
        background-color: white
    &:focus
        color: white !important
        background-color: $blue !important
        border-color: $blue !important
        outline: none
        -webkit-box-shadow: none !important
        -moz-box-shadow: none !important
        box-shadow: none !important
    &:disabled
        opacity: 1
        pointer-events: none
        cursor: default !important
        background-color: transparent
    &.active
        color: white !important
        background-color: $blue !important
        border-color: $blue !important

.btn-outline-primary
    &:disabled
        opacity: 1
        color: white
        background-color: $blue
        cursor: default !important
</style>
